<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getBranchOperation)" class="refresh-btn">刷新</el-button>
    <div class="wrap count">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="医馆名称">
            <el-select v-model="searchForm.deptIds" multiple placeholder="请选择医馆名称">
              <el-option v-for="item in deptOptions" :key="item.value"  :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="月份" class="w340">
            <el-date-picker v-model="searchForm.date" value-format="yyyy-MM" type="monthrange" align="right"
            unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
            :picker-options="pickerOptions" @change="val => $setDates(val, getBranchOperation)"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getBranchOperation, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getBranchOperation, { deptIds: [], dates: [], date: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button @click="$exportSummary(searchForm, '/report/export/deptEarnings', '分馆经营统计')"
        icon="el-icon-download" type="primary">导出报表</el-button>
      </div>
      <!-- 分馆经营统计列表 -->
      <el-table v-loading="loading" :data="BranchOperationList" :max-height="tableHeight" border>
        <el-table-column fixed="left" prop="deptName" width="80" label="分馆名称"/>
        <el-table-column fixed="left" prop="doctorName" width="80" label="员工姓名"/>
        <el-table-column label="每月销售统计(元)">
          <template>
            <el-table-column v-for="(item, i) in searchForm.dates" :label="item.substr(0,7)" min-width="90" :key="i">
              <template slot-scope="scope">{{scope.row.totalPrices[i].price}}</template>
            </el-table-column>
            <el-table-column label="销售总额" min-width="90">
              <template slot-scope="scope">{{scope.row.totalPrices[monthNum].price}}</template>
            </el-table-column>
          </template>
        </el-table-column>
        <el-table-column label="每月毛利统计(元)">
          <template>
            <el-table-column v-for="(item, i) in searchForm.dates" :label="item.substr(0,7)" min-width="90" :key="i">
              <template slot-scope="scope">{{scope.row.maoriForeheads[i].price}}</template>
            </el-table-column>
            <el-table-column label="毛利总额" min-width="90">
              <template slot-scope="scope">{{scope.row.maoriForeheads[monthNum].price}}</template>
            </el-table-column>
          </template>
        </el-table-column>
        <el-table-column label="每月门诊统计(个)">
          <template>
            <el-table-column v-for="(item, i) in searchForm.dates" :label="item.substr(0,7)" min-width="90" :key="i">
              <template slot-scope="scope">{{scope.row.outpatientNumbers[i].outpatientNumber}}</template>
            </el-table-column>
            <el-table-column label="门诊总和" min-width="90">
              <template slot-scope="scope">{{scope.row.outpatientNumbers[monthNum].outpatientNumber}}</template>
            </el-table-column>
          </template>
        </el-table-column>
        <el-table-column label="每月推荐统计(个)">
          <template>
            <el-table-column v-for="(item, i) in searchForm.dates" :label="item.substr(0,7)" min-width="90" :key="i">
              <template slot-scope="scope">{{scope.row.outpatientNumbers[i].recommendNumber}}</template>
            </el-table-column>
            <el-table-column label="推荐总和" min-width="90">
              <template slot-scope="scope">{{scope.row.outpatientNumbers[monthNum].recommendNumber}}</template>
            </el-table-column>
          </template>
        </el-table-column>
        <el-table-column label="每月客单统计(个)">
          <template>
            <el-table-column v-for="(item, i) in searchForm.dates" :label="item.substr(0,7)" min-width="90" :key="i">
              <template slot-scope="scope">{{scope.row.totalPrices[i].number}}</template>
            </el-table-column>
            <el-table-column label="客单总和" min-width="90">
              <template slot-scope="scope">{{scope.row.totalPrices[monthNum].number}}</template>
            </el-table-column>
          </template>
        </el-table-column>
        <el-table-column label="每月坐诊统计(个)">
          <template>
            <el-table-column v-for="(item, i) in searchForm.dates" :label="item.substr(0,7)" min-width="90" :key="i">
              <template slot-scope="scope">{{scope.row.visitNumbers[i].number}}</template>
            </el-table-column>
            <el-table-column label="坐诊总和" min-width="90">
              <template slot-scope="scope">{{scope.row.visitNumbers[monthNum].number}}</template>
            </el-table-column>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getBranchOperation)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </div>
</template>

<script lang="js">
import { BranchOperation } from "@/api/statement"; // 报表统计请求
export default {
  name: 'DeptOperation',
  data() {
    return {
      loading: false, // 加载中
      searchForm: { deptIds: [], dates: [], date: null }, // 查询表单
      BranchOperationList: [], // 分馆经营统计列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      deptOptions: this.$session.get('options'), // 医馆列表
      pickerOptions: { // 排班日期可选范围
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: this.$shortcuts
      },
      monthNum: 0, // 月份数量
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.$forceUpdate();
    this.$setCurMonth(this.getBranchOperation);
  },
  methods: {
    // 请求所有分馆经营统计列表
    async getBranchOperation() {
      let { rows, code, total } = await BranchOperation(this.currentPage, this.pageSize, this.searchForm);
      if (code == 200) {
        this.BranchOperationList = rows;
        this.total = total;
      }
      this.loading = false;
    }
  },
};
</script>